import { apiService } from './api';

export interface CreateAssignmentInput {
  stakeholderId: string;
  organizationId: string;
  role: string;
  department?: string;
  startDate: string; // ISO
  endDate?: string;  // ISO
  isCurrent?: boolean;
}

export interface UpdateAssignmentInput {
  role?: string;
  department?: string;
  startDate?: string;
  endDate?: string;
  isCurrent?: boolean;
}

export interface AssignmentDto {
  id: string;
  stakeholderId: string;
  organizationId: string;
  organizationName?: string;
  role: string;
  department?: string;
  startDate: string;
  endDate?: string;
  isCurrent: boolean;
  createdAt: string;
  updatedAt: string;
}

class AssignmentService {
  private readonly basePath = '/api/assignments';

  async create(input: CreateAssignmentInput): Promise<AssignmentDto> {
    const res = await apiService.post(this.basePath, input);
    return res.data;
  }

  async update(id: string, input: UpdateAssignmentInput): Promise<AssignmentDto> {
    const res = await apiService.patch(`${this.basePath}/${id}`, input);
    return res.data;
  }

  async end(id: string, endDate: string): Promise<AssignmentDto> {
    const res = await apiService.patch(`${this.basePath}/${id}/end`, { endDate });
    return res.data;
  }

  async getByStakeholder(stakeholderId: string): Promise<AssignmentDto[]> {
    const res = await apiService.get(`${this.basePath}/stakeholder/${stakeholderId}`);
    return res.data;
  }

  async getCurrentByStakeholder(stakeholderId: string): Promise<AssignmentDto[]> {
    const res = await apiService.get(`${this.basePath}/stakeholder/${stakeholderId}/current`);
    return res.data;
  }

  async delete(id: string): Promise<void> {
    await apiService.delete(`${this.basePath}/${id}`);
  }
}

export const assignmentService = new AssignmentService();

